import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import {
  EquipmentHttpService,
  ProjectCategoryHttpService,
  ScopingHttpService,
  SiteHttpService,
} from '@core/services/http';
import { getIdParamFromUrl } from '@core/utils/methods';
import store from '@store/index';
import { EngineeringScopingState } from '@store/reducers/engineering/scoping.reducer';

export class ScopingDetailsResolver implements Resolver {
  private static get _state(): EngineeringScopingState {
    return store.getState()?.engineering?.scoping || [];
  }

  async resolve(): Promise<void> {
    const [id] = getIdParamFromUrl();

    await HttpService.getHttpRequests(ScopingHttpService).getScoping(id);
    await HttpService.getHttpRequests(
      ProjectCategoryHttpService,
    ).getProjectCategories();
    await HttpService.getHttpRequests(
      SiteHttpService,
    ).getFALocationNumberOptions();
    await HttpService.getHttpRequests(EquipmentHttpService).getEquipmentTypes();

    if (ScopingDetailsResolver._state?.equipmentTypeNames?.length) {
      await HttpService.getHttpRequests(
        EquipmentHttpService,
      ).getEquipmentsByTypes(ScopingDetailsResolver._state?.equipmentTypeNames);
    }
  }
}
